import { SET_BTN_ACTIVITY, SET_TAG_ON_FORWARD_STATUS } from '../../actions/types';

export const INITIAL_STATE = {
  btnActivity: {
    allTakeBtn: true,
    allForwardBtn: true,
    escalateTakeBtn: true,
    escalateForwardBtn: true,
    escalateRejectBtn: true,
    sendMessageBtn: true,
    unhideConversation: true,
  },
  tagOnForwardActive: false,
};

export const BUTTON_IDS = {
  allTakeBtn: 'allTakeBtn',
  allForwardBtn: 'allForwardBtn',
  escalateTakeBtn: 'escalateTakeBtn',
  escalateForwardBtn: 'escalateForwardBtn',
  escalateRejectBtn: 'escalateRejectBtn',
  sendMessageBtn: 'sendMessageBtn',
  unhideConversationBtn: 'unhideConversationBtn',
};

const buttons = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BTN_ACTIVITY:
      return { ...state, btnActivity: { ...state.btnActivity, [action.buttonId]: action.isActive } };
    case SET_TAG_ON_FORWARD_STATUS:
      return { ...state, tagOnForwardActive: action.value };
    default:
      return state;
  }
};

export default buttons;
